import React from 'react';
import classNames from 'classnames';
import { FloatingDropdown } from '../../../ui';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { useApi } from '../../context/api-context/use-api';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { HEADER_SCOPE, SORTING_SELECTOR } from '../../../common/constants/data-hooks';
import { useCommentsSort } from './use-comments-sort';
import styles from './comments-sort.module.scss';
export const CommentsSort = ({ className, selectedSort }) => {
    const { blackAndWhiteModals } = useConfiguration();
    const isMobile = useApi(getIsMobile);
    const t = useTranslate();
    const { sortOptions, onSortChange } = useCommentsSort();
    return (React.createElement(FloatingDropdown
    // The sort selector renders outside the `wc-header` div but is part of the header's
    // styling surface — the scope token keeps `--wcHeaderSort*` overrides reaching it.
    , { "data-hook": classNames(SORTING_SELECTOR, HEADER_SCOPE), className: classNames(styles.root, isMobile && styles.isMobile, !!blackAndWhiteModals && styles.blackAndWhite, className), label: isMobile ? '' : t('header.sort-by'), "aria-label": isMobile ? t('header.sort-by') : undefined, value: selectedSort, options: sortOptions, onChange: (option) => onSortChange?.(option.id) }));
};
//# sourceMappingURL=comments-sort.js.map